"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateEnvironmentRequest = exports.CreateAppRequest = exports.PartialApp = void 0;
var common_1 = require("../common");
var Service_1 = require("./Service");
var json2typescript_1 = require("json2typescript");
var PartialApp = (function () {
    function PartialApp(partial) {
        this.id = '';
        this.clientAppId = '';
        this.name = '';
        this.product = '';
        this.location = common_1.Location.Virginia;
        this.providerRegion = common_1.ProviderRegion.AWSProviderRegionUSEast1;
        this.deploymentModel = common_1.DeploymentModel.Global;
        this.domainId = '';
        this.groupId = '';
        this.lastUsed = 0;
        this.lastModified = 0;
        this.environment = common_1.AppEnvironment.None;
        this.templateId = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('client_app_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "clientAppId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('product'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "product", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('location'),
        __metadata("design:type", String)
    ], PartialApp.prototype, "location", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('provider_region'),
        __metadata("design:type", String)
    ], PartialApp.prototype, "providerRegion", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('deployment_model'),
        __metadata("design:type", String)
    ], PartialApp.prototype, "deploymentModel", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('domain_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "domainId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('group_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "groupId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_used'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "lastUsed", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('last_modified'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "lastModified", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('environment', String, true),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "environment", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('template_id', String, true),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "templateId", void 0);
    PartialApp = __decorate([
        (0, json2typescript_1.JsonObject)('PartialApp'),
        __metadata("design:paramtypes", [Object])
    ], PartialApp);
    return PartialApp;
}());
exports.PartialApp = PartialApp;
var CreateAppRequest = (function () {
    function CreateAppRequest(partial) {
        this.name = '';
        this.location = undefined;
        this.providerRegion = undefined;
        this.deploymentModel = undefined;
        this.environment = undefined;
        this.templateId = undefined;
        this.dataSource = undefined;
        this.createCluster = undefined;
        this.createClusterRegion = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], CreateAppRequest.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('location', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "location", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('provider_region', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "providerRegion", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('deployment_model', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "deploymentModel", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('environment', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "environment", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('template_id', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "templateId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('data_source', Service_1.ServiceDesc, true),
        __metadata("design:type", Service_1.ServiceDesc)
    ], CreateAppRequest.prototype, "dataSource", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('create_cluster', Boolean, true),
        __metadata("design:type", Boolean)
    ], CreateAppRequest.prototype, "createCluster", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('create_cluster_region', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "createClusterRegion", void 0);
    CreateAppRequest = __decorate([
        (0, json2typescript_1.JsonObject)('CreateAppRequest'),
        __metadata("design:paramtypes", [Object])
    ], CreateAppRequest);
    return CreateAppRequest;
}());
exports.CreateAppRequest = CreateAppRequest;
var UpdateEnvironmentRequest = (function () {
    function UpdateEnvironmentRequest(partial) {
        this.environment = common_1.AppEnvironment.None;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('environment'),
        __metadata("design:type", Object)
    ], UpdateEnvironmentRequest.prototype, "environment", void 0);
    UpdateEnvironmentRequest = __decorate([
        (0, json2typescript_1.JsonObject)('UpdateEnvironmentRequest'),
        __metadata("design:paramtypes", [Object])
    ], UpdateEnvironmentRequest);
    return UpdateEnvironmentRequest;
}());
exports.UpdateEnvironmentRequest = UpdateEnvironmentRequest;
//# sourceMappingURL=App.js.map